/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Ua_LeadInputs */

const en_bot_ua_lead = /** @type {(inputs: Bot_Ua_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every request carries the BystepBot token in its User-Agent and comes from the same IP address as bystep.dev.`)
};

const id_bot_ua_lead = /** @type {(inputs: Bot_Ua_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap permintaan membawa token BystepBot di User-Agent dan datang dari alamat IP yang sama dengan bystep.dev.`)
};

/**
* | output |
* | --- |
* | "Every request carries the BystepBot token in its User-Agent and comes from the same IP address as bystep.dev." |
*
* @param {Bot_Ua_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_ua_lead = /** @type {((inputs?: Bot_Ua_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Ua_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_ua_lead(inputs)
	return en_bot_ua_lead(inputs)
});